import { TemplateNavHeaderStyles } from "./NavHeader.styles"

const svgOpenTemplate = document.createElement('template')
svgOpenTemplate.innerHTML = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      class="bi bi-list"
      viewBox="0 0 16 16"
    >
      <path
        d="M2.5 12.5a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11zm0-4a.5.5 0 0 1 0-1h11a.5.5 0 0 1 0 1h-11z"
      />
    </svg>
`

const svgCloseTemplate = document.createElement('template')
svgCloseTemplate.innerHTML = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      fill="currentColor"
      class="bi bi-x"
      viewBox="0 0 16 16"
    >
      <path
        d="M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708z"
      />
    </svg>
`

const t = document.createElement('template')
t.innerHTML = `
<!-- Hamburger (mobile only) -->
<div id="mobile-menu-toggle" class="ham-btn d-md-none" tabindex="0">   
</div>
`

class NavHeaderUtilityHamburger extends HTMLElement {
  constructor() {
    super()

    const shadow = this.attachShadow({ mode: 'open' })
    shadow.appendChild(TemplateNavHeaderStyles.content.cloneNode(true))
    shadow.appendChild(t.content.cloneNode(true))
  }

  connectedCallback() {
    console.log('NavHeaderUtilityHamburger connectedCallback', this)

    const shadow = this.shadowRoot
    if (shadow) {
      const btn = shadow.getElementById('mobile-menu-toggle')
      if (btn) {
        this.setToggle(btn)
        btn.addEventListener('click', () => {
          btn.classList.toggle('open')
          this.setToggle(btn)

          this.dispatchEvent(
            new CustomEvent('toggle-hamburger', {
              bubbles: true, // allow event to bubble up to parent
              composed: true, // allow event to cross shadow DOM boundary
            }),
          )
        })
      }
    }
  }

  setToggle(btn: HTMLElement) {
    if (!btn) return
    if (btn.classList.contains('open')) {
      btn.innerHTML = svgCloseTemplate.innerHTML
    } else {
      btn.innerHTML = svgOpenTemplate.innerHTML
    }
  }
}

if (!customElements.get('ts-navheader-utility-hamburger')) {
  customElements.define('ts-navheader-utility-hamburger', NavHeaderUtilityHamburger)
}
export { NavHeaderUtilityHamburger }
